class CartNotification extends HTMLElement {
  constructor() {
    super(), (this.notification = document.getElementById("cart-notification"));
  }
  renderContents(t) {
    (document.getElementById("cart-notification-default").innerHTML = ""),
      (this.productId = t.id),
      this.getSectionsToRender().forEach((e) => {
        document.getElementById(e.id).innerHTML = this.getSectionInnerHTML(
          t.sections[e.id],
          e.selector
        );
      });
    var e = document.querySelector("#cart-icon-bubble");
    "false" == e.getAttribute("aria-expanded") && e.click();
  }
  getSectionsToRender() {
    return [
      { id: "cart-notification-product" },
      { id: "cart-notification-button" },
      { id: "cart-icon-bubble" },
      { id: "cart-upsell" },
      { id: "cart-drawer-gift" },
    ];
  }
  getSectionInnerHTML(t, e = ".shopify-section") {
    return new DOMParser().parseFromString(t, "text/html").querySelector(e)
      .innerHTML;
  }
  handleBodyClick(t) {
    const e = t.target;
    if (e !== this.notification && !e.closest("cart-notification")) {
      const t = e.closest("details-disclosure");
      (this.activeElement = t ? t.querySelector("summary") : null),
        this.close();
    }
  }
  setActiveElement(t) {
    this.activeElement = t;
  }
}
customElements.define("cart-notification", CartNotification);
